import { render, staticRenderFns } from "./Medidas.vue?vue&type=template&id=563ec2e6&"
import script from "./Medidas.vue?vue&type=script&lang=js&"
export * from "./Medidas.vue?vue&type=script&lang=js&"
import style0 from "./Medidas.vue?vue&type=style&index=0&id=563ec2e6&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports